import tw from 'twin.macro';

const TabSwitchContainer = tw.div`flex gap-[8px] items-center border-b-[3px] border-b-gray-1 box-border`;
const TabSwitchItem = tw.div`flex justify-center items-center p-[8px] pb-[12px] cursor-pointer box-border mb-[-3px] border-b-[3px] border-b-transparent text-[11px] text-text-and-icon-muted-2 font-medium`;

type TabSwitchProps = {
  tabs: {
    id: string;
    label: string | JSX.Element;
  }[];
  selectedTab: string;
  setSelectedTab: (id: string) => void;
};

export const TabSwitch = ({ tabs, selectedTab, setSelectedTab }: TabSwitchProps) => {
  return (
    <TabSwitchContainer>
      {tabs.map((tab) => (
        <TabSwitchItem
          key={tab.id}
          css={[selectedTab === tab.id && tw`!border-b-accent-1 !text-accent-1 !font-bold`]}
          onClick={() => setSelectedTab(tab.id)}>
          {tab.label}
        </TabSwitchItem>
      ))}
    </TabSwitchContainer>
  );
};
